const getters = {
  getToken: state => state.token,
  getAuthenticated: state => state.isAuthenticated,
  getUserInfo: state => state.userInfo,
  getUserRoles: state => state.userRoles,
  getChatToken: state => state.chatToken
}

export default getters
